// extracted by mini-css-extract-plugin
export default {"menumain":"Menu_menumain__Eagge","fsearchbox":"Menu_fsearchbox__kFQSV","innersearch":"Menu_innersearch__Mtd2Y"};